import { Script } from '.';
import PWCore from '../core';
export class SUDT {
    constructor(issuerLockHash, info) {
        this.issuerLockHash = issuerLockHash;
        this.info = info;
    }
    toTypeScript() {
        const { codeHash, hashType } = PWCore.config.sudtType.script;
        return new Script(codeHash, this.issuerLockHash, hashType);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VkdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2RlbHMvc3VkdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sR0FBRyxDQUFDO0FBQzNCLE9BQU8sTUFBTSxNQUFNLFNBQVMsQ0FBQztBQU83QixNQUFNLE9BQU8sSUFBSTtJQUNmLFlBQXFCLGNBQXNCLEVBQVcsSUFBZTtRQUFoRCxtQkFBYyxHQUFkLGNBQWMsQ0FBUTtRQUFXLFNBQUksR0FBSixJQUFJLENBQVc7SUFBRyxDQUFDO0lBRXpFLFlBQVk7UUFDVixNQUFNLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQztRQUM3RCxPQUFPLElBQUksTUFBTSxDQUFDLFFBQVEsRUFBRSxJQUFJLENBQUMsY0FBYyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBQzdELENBQUM7Q0FDRiJ9